/** Esperanto IPA overrides for words not in the dictionary. */
export const eo: Record<string, string> = {
  // G2P handles all Esperanto words with correct penultimate stress.
  // Overrides here are only needed for words where the IPA dictionary
  // has an incorrect entry that needs correction.
};
